import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DocumentViewerResult } from '../../service/document-viewer.service';

/**
 * Document viewer content component for use INSIDE a mat-sidenav.
 * Does not include the sidenav wrapper itself - only the toolbar and content.
 * Use this when you already have a mat-sidenav-container in your template.
 */
@Component({
  selector: 'app-document-viewer-sidenav',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './document-viewer-sidenav.component.html',
  styleUrls: ['./document-viewer-sidenav.component.css']
})
export class DocumentViewerSidenavComponent {
  @Input() document: DocumentViewerResult | null = null;
  @Input() title = 'Document Viewer';
  @Output() close = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() openNewTab = new EventEmitter<void>();
}